import { render, staticRenderFns } from "./FaceAttributes.vue?vue&type=template&id=0f23fbb0&scoped=true"
import script from "./FaceAttributes.vue?vue&type=script&lang=js"
export * from "./FaceAttributes.vue?vue&type=script&lang=js"
import style0 from "./FaceAttributes.vue?vue&type=style&index=0&id=0f23fbb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f23fbb0",
  null
  
)

export default component.exports